import baseConstants from '../Constants/baseConstants';

export const usergui = {
    metrics: [],
    calendar: baseConstants.nw_config_userguiconfig_calendar,
    numbers: baseConstants.nw_config_userguiconfig_numbers,
    // Add here other defaults user's config
};
